export default __webpack_public_path__ + "static/media/PacketPulse.b6cd36496961c3819107e26bd2326f64.webp";